import React from 'react'
import { useTranslation } from 'react-i18next'
import learningItemInfoText from '../../../state/calculations/learningItemInfoText'
import { useLearningItems } from '../../../state/entities'
import useLearningItemSuggestions from '../../../state/queries/useLearningItemSuggestions'
import singleItemSelect, { formikConnectedSingleItemSelect } from '../../basics/ItemSelect/singleItemSelect'
import LearningItemAvatar from '../../LearningItemAvatar/LearningItemAvatar'
import styles from './SelectLearningItem.module.scss'

/**********************************************************************
 * SelectLearningItem
 **********************************************************************/
const SelectLearningItem = singleItemSelect({
  useSuggestions: () => useLearningItemSuggestions(null, ['live_training', 'online_class', 'hybrid', 'webinar']),
  renderItemDescription: (learningItem) => learningItem.title,
  renderSelectedItemComponent: ({ item: learningItem }) => {
    const { t } = useTranslation()
    return (
      <>
        <LearningItemAvatar learningItem={learningItem} />
        <div className={styles.infoFields}>
          <span className={styles.name}>{learningItem.title}</span>
          <span className={styles.info}>{learningItemInfoText(t, learningItem)}</span>
        </div>
      </>
    )
  },
  renderEmptyComponent: () => {
    const { t } = useTranslation()
    return <div className={styles.empty}>{t('manage learning.no learning item selected')}</div>
  },
  className: styles.SelectLearningItem,
})

/**********************************************************************
 * SelectLearningItemFormik
 **********************************************************************/
export const SelectLearningItemFormik = formikConnectedSingleItemSelect({
  component: SelectLearningItem,
  useItem: (uuid) => useLearningItems(uuid ? [uuid] : []).learningItems[0],
  mapItem: (learningItem) => (learningItem ? learningItem.uuid : null),
})

/**********************************************************************
 * SelectLearningItemPath
 **********************************************************************/
const SelectLearningItemPath = singleItemSelect({
  useSuggestions: () => useLearningItemSuggestions(null, ['learning_path']),
  renderItemDescription: (learningItem) => learningItem.title,
  renderSelectedItemComponent: ({ item: learningItem }) => {
    const { t } = useTranslation()
    return (
      <>
        <LearningItemAvatar learningItem={learningItem} />
        <div className={styles.infoFields}>
          <span className={styles.name}>{learningItem.title}</span>
          <span className={styles.info}>{learningItemInfoText(t, learningItem)}</span>
        </div>
      </>
    )
  },
  renderEmptyComponent: () => {
    const { t } = useTranslation()
    return <div className={styles.empty}>{t('manage learning.no learning item selected')}</div>
  },
  className: styles.SelectLearningItem,
})

/**********************************************************************
 * SelectLearningItemPathFormik
 **********************************************************************/
export const SelectLearningItemPathFormik = formikConnectedSingleItemSelect({
  component: SelectLearningItemPath,
  useItem: (uuid) => useLearningItems(uuid ? [uuid] : []).learningItems[0],
  mapItem: (learningItem) => (learningItem ? learningItem.uuid : null),
})
